// extracted by mini-css-extract-plugin
export default {"switch":"Assemblies_switch__Q6c1i","header":"Assemblies_header__NACe8","pagination":"Assemblies_pagination__tltRv"};